import './index.css';

interface ParticipantsListProps {
  participants: string[];
  host: string;
  currentUser: string;
  isCurrentUserHost: boolean;
  onTransferHost?: (username: string) => void;
  onKick?: (username: string) => void;
  className?: string;
}

const ParticipantsList = ({
  participants,
  host,
  currentUser,
  className = '',
}: ParticipantsListProps) => (
  <div className={`participants-container ${className}`}>
    <div className='participants-header'>
      <h2 className='participants-title'>
        Participants <span className='participant-count'>({participants.length})</span>
      </h2>
    </div>

    <ul className='participants-list'>
      {participants.length === 0 ? (
        <li className='participant-item empty-message'>No participants yet</li>
      ) : (
        participants.map(participant => (
          <li
            key={participant}
            className={`participant-item ${participant === host ? 'host' : ''} ${
              participant === currentUser ? 'current-user' : ''
            }`}>
            <div className='participant-info'>
              <span className='participant-icon'>
                {participant === host ? (
                  <i className='material-icons text-xl'>person</i>
                ) : (
                  <i className='material-icons text-xl'>group</i>
                )}
              </span>
              <span className='participant-name' title={participant}>
                {participant}
                {participant === currentUser && <span className='you-badge'> (You)</span>}
              </span>
            </div>
          </li>
        ))
      )}
    </ul>

    <div className='host-indicator'>
      <i className='material-icons text-xl'>person</i>
      <span className='host-label'>Host:</span>
      <span className='host-name' title={host}>
        {host}
        {host === currentUser && <span className='you-badge'> (You)</span>}
      </span>
    </div>
  </div>
);

export default ParticipantsList;
